import React from 'react';
import PropTypes from 'prop-types';

function PriceRangeInput({ value, onChange, disabled, placeholder }) {
    return (
        <input
            type="number"
            className="PriceRangeFilter__Input sales__PriceRangeInput ui-input"
            inputMode="numeric"
            pattern="[0-9]{1, 10}"
            placeholder={placeholder}
            value={value || ''}
            min="0"
            max="9999999999"
            onChange={onChange}
            disabled={disabled}
        />
    );
}

PriceRangeInput.propTypes = {
    placeholder: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    disabled: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired
};

export default PriceRangeInput;



// WEBPACK FOOTER //
// ./src/js/modules/PriceRangeFilter/components/PriceRangeInput.js